import React, {useState} from 'react';
import Header from "../header/header";
import SideBar from "../sideBar/sideBar";
import HeaderBeforeLogin from "../header/header-before-login";
import Footer from "../footer";
import {useSelector} from "react-redux";

const Index = ({ children }) => {
  const isLogin = useSelector((state) => state.user.token)
  return (
    <div>
      {
        isLogin ?
          <>
            <SideBar/>
            <Header/>
            {children}
          </>
        :
          <>
            <HeaderBeforeLogin/>
            {children}
            <Footer/>
          </>
      }

    </div>
  );
};

export default Index;
